import React from "react";
import foto from "../../../img/mediakit/lamina02-foto.jpg";
import { BanderaChile, BanderaPeru, FilaBanderas } from "./Banderas";
import { Foto } from "./Foto";
import styles from "./Lamina02TorresEjecutivas.module.scss";

function Lamina02TorresEjecutivas() {
  return (
    <div className={styles.lamina} data-mk-lamina="torres-ejecutivas">
      <Foto src={foto} className={styles.foto} data-mk="foto" />

      <div className={styles.columna}>
        <h1 className={styles.titulo} data-mk="titulo">
          Torres
          <br />
          Ejecutivas
        </h1>

        <div className={styles.texto} data-mk="texto">
          <p>Pantallas en ascensores, puntos de circulación, hall de espera y pantallas de gran formato.</p>
          <p>
            Espacio con <span className={styles.destacado}>características de impacto extraordinarias</span>; ambiente
            de tiempo de espera forzoso, libre de distracciones, gran cautividad y alta frecuencia de uso.
          </p>
          <p>
            Atributos difíciles de encontrar en un solo medio y que{" "}
            <span className={styles.destacado}>garantizan la recepción del mensaje.</span>
          </p>
        </div>

        <FilaBanderas data-mk="banderas">
          <BanderaChile />
          <BanderaPeru />
        </FilaBanderas>
      </div>
    </div>
  );
}

export default Lamina02TorresEjecutivas;
